'use strict';

var dom = require('form-widget-dom');

module.exports = {

	isFullnameType: function($col) {

		return $col.hasClass('fb-fullname-type');

	},

	getVal: function($col) {

		var $els = dom.getFieldInputs($col);
		var vals = [];

		$els.each(function(i) {

			var $el = $els.eq(i);

			vals.push({
				name: dom.getNestedFieldTitleText($el),
				value: $el.val()
			});

		});

		return {
			name: 'Full Name',
			value: vals
		};

	}

};